import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IntranetApiResponse, IntranetUiResponse } from '../models/intranet-maestro';
import { WebService } from './webservices.service';

@Injectable({ providedIn: 'root' })
export class IntranetSeguridadService {
  private readonly baseUrl = `${environment.URL_WEBSERVICES}/intranet/seguridad`;

  constructor(private readonly webService: WebService) {}

  post<T>(path: string, payload: Record<string, unknown> = {}): Observable<IntranetUiResponse<T>> {
    return this.webService.peticionPost(`${this.baseUrl}/${path}`, payload, true).pipe(
      map((response) => this.normalizar<T>(response)),
    );
  }

  private normalizar<T>(response: unknown): IntranetUiResponse<T> {
    const payload = (response ?? {}) as IntranetApiResponse<T>;
    return {
      isSuccess: typeof payload.isSuccess === 'boolean' ? payload.isSuccess : (payload.success ?? false),
      message: payload.message ?? '',
      value: (typeof payload.isSuccess === 'boolean' ? payload.value : payload.data) as T | null,
    };
  }
}
